export function getCurrentTimestamp(firestore) {
    return firestore.Timestamp.fromDate(new Date());
}

export function getTimestampOffsetByDays(firestore, daysOffset) {
    var offsetDate = new Date();
    offsetDate.setDate(offsetDate.getDate() - daysOffset);
    return firestore.Timestamp.fromDate(offsetDate);
}